import React from 'react';
// import CustomNavbar from '../components/common/CustomNavbar'; // Import the Navbar component
// import Footer from '../components/common/Footer';

import './oncology.css'; // Import the CSS file for styling

import bg2 from '../assets/img/bg-2 1.png';
import pngwing from '../assets/img/pngwing.png';
import department10 from '../assets/img/departments-5 1 (4).png';

const Oncology = () => {
  return (
    <>
      {/* <CustomNavbar /> */}
      <div className="O-content">
        <h1 className="O-nav-heading">Oncology</h1>
        <p className="O-paragraph1">
          Comprehensive Revenue Cycle Management (RCM) Services by RDS
        </p>
      </div>
 
          <div className="O-overlay-content">
            <h1 className="O-heading3">
              <span className="O-heading-part11">Innovative revenue cycle management solutions for <br/></span>
              <span className="O-heading-part22">  oncology practices</span>
            </h1>
            <p className="O-paragraph2">
            We assemble a dedicated team comprising oncology experts, billing professionals, and process specialists <br/> aimed at enhancing the financial vitality of your practice and bolstering revenue streams. Our approach  <br/> involves collaborating closely with you to pinpoint strategic objectives, fostering new avenues for revenue <br/> generation, and streamlining expenses.<br/> With our comprehensive service, we ensure a tailored strategy to elevate your practice's financial <br/> performance.
            </p>
          </div>
          <div className="O-image-container2">
        <img src={bg2} alt="description" className="O-my-image1" />
        <img src={department10} alt="Your Image" className="O-dp-image" />
        <div className="O-overlay-content1">
          <h1 className="O-heading4">
            <span className="O-heading-part11">We are more than a billing </span>
            <span className="O-heading-part22"> service</span>
          </h1>
          <p className="O-paragraph201">
          We're dedicated to streamlining and enhancing the billing and payment process  in oncology.<br/> Our solutions revolve around refining processes and integrating  technologies to boost revenue.<br/> We're truly enthusiastic about the tangible benefits these services offer to our community <br/>oncology partners.They empower practice teams, driving performance, and Flatiron stands out <br/> as a leader in revenue cycle solutions.
          </p>
        </div>
        
      </div> 

      <div className="O-gradient-container">
          <img src={pngwing} alt="Your Image" className="O-background-image" />
          <div className="O-container-wrapper">
            <h2 className="O-container-heading">Here's what we offer:</h2>

            <div class="O-container-wrapper">
 
 <div class="O-container-item">
   <div class="O-checkbox-container">
     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
       <path d="M16.0003 31.8337C7.25558 31.8337 0.166992 24.7451 0.166992 16.0003C0.166992 7.25558 7.25558 0.166992 16.0003 0.166992C24.7451 0.166992 31.8337 7.25558 31.8337 16.0003C31.8337 24.7451 24.7451 31.8337 16.0003 31.8337ZM16.0003 28.667C19.3597 28.667 22.5816 27.3325 24.957 24.957C27.3325 22.5816 28.667 19.3597 28.667 16.0003C28.667 12.6409 27.3325 9.4191 24.957 7.04364C22.5816 4.66818 19.3597 3.33366 16.0003 3.33366C12.6409 3.33366 9.4191 4.66818 7.04364 7.04364C4.66818 9.4191 3.33366 12.6409 3.33366 16.0003C3.33366 19.3597 4.66818 22.5816 7.04364 24.957C9.4191 27.3325 12.6409 28.667 16.0003 28.667ZM14.4217 22.3337L7.70366 15.6156L9.94249 13.3767L14.4217 17.856L23.3787 8.89907L25.6175 11.1379L14.4217 22.3337Z" fill="#076AFF"/>
     </svg>
   </div>
   <div class="O-content-container1">
     <p> Core billing services</p>
   </div>
 </div>
 <div class="O-container-item">
   <div class="O-checkbox-container">
     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
       <path d="M16.0003 31.8337C7.25558 31.8337 0.166992 24.7451 0.166992 16.0003C0.166992 7.25558 7.25558 0.166992 16.0003 0.166992C24.7451 0.166992 31.8337 7.25558 31.8337 16.0003C31.8337 24.7451 24.7451 31.8337 16.0003 31.8337ZM16.0003 28.667C19.3597 28.667 22.5816 27.3325 24.957 24.957C27.3325 22.5816 28.667 19.3597 28.667 16.0003C28.667 12.6409 27.3325 9.4191 24.957 7.04364C22.5816 4.66818 19.3597 3.33366 16.0003 3.33366C12.6409 3.33366 9.4191 4.66818 7.04364 7.04364C4.66818 9.4191 3.33366 12.6409 3.33366 16.0003C3.33366 19.3597 4.66818 22.5816 7.04364 24.957C9.4191 27.3325 12.6409 28.667 16.0003 28.667ZM14.4217 22.3337L7.70366 15.6156L9.94249 13.3767L14.4217 17.856L23.3787 8.89907L25.6175 11.1379L14.4217 22.3337Z" fill="#076AFF"/>
     </svg>
   </div>
   <div class="O-content-container1">
     <p> Core billing services</p>
   </div>
 </div>
 <div class="O-container-item">
   <div class="O-checkbox-container">
     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
       <path d="M16.0003 31.8337C7.25558 31.8337 0.166992 24.7451 0.166992 16.0003C0.166992 7.25558 7.25558 0.166992 16.0003 0.166992C24.7451 0.166992 31.8337 7.25558 31.8337 16.0003C31.8337 24.7451 24.7451 31.8337 16.0003 31.8337ZM16.0003 28.667C19.3597 28.667 22.5816 27.3325 24.957 24.957C27.3325 22.5816 28.667 19.3597 28.667 16.0003C28.667 12.6409 27.3325 9.4191 24.957 7.04364C22.5816 4.66818 19.3597 3.33366 16.0003 3.33366C12.6409 3.33366 9.4191 4.66818 7.04364 7.04364C4.66818 9.4191 3.33366 12.6409 3.33366 16.0003C3.33366 19.3597 4.66818 22.5816 7.04364 24.957C9.4191 27.3325 12.6409 28.667 16.0003 28.667ZM14.4217 22.3337L7.70366 15.6156L9.94249 13.3767L14.4217 17.856L23.3787 8.89907L25.6175 11.1379L14.4217 22.3337Z" fill="#076AFF"/>
     </svg>
   </div>
   <div class="O-content-container1">
     <p> Core billing services</p>
   </div>
 </div>
 <div class="O-container-item-1">
   <div class="O-checkbox-container">
     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
       <path d="M16.0003 31.8337C7.25558 31.8337 0.166992 24.7451 0.166992 16.0003C0.166992 7.25558 7.25558 0.166992 16.0003 0.166992C24.7451 0.166992 31.8337 7.25558 31.8337 16.0003C31.8337 24.7451 24.7451 31.8337 16.0003 31.8337ZM16.0003 28.667C19.3597 28.667 22.5816 27.3325 24.957 24.957C27.3325 22.5816 28.667 19.3597 28.667 16.0003C28.667 12.6409 27.3325 9.4191 24.957 7.04364C22.5816 4.66818 19.3597 3.33366 16.0003 3.33366C12.6409 3.33366 9.4191 4.66818 7.04364 7.04364C4.66818 9.4191 3.33366 12.6409 3.33366 16.0003C3.33366 19.3597 4.66818 22.5816 7.04364 24.957C9.4191 27.3325 12.6409 28.667 16.0003 28.667ZM14.4217 22.3337L7.70366 15.6156L9.94249 13.3767L14.4217 17.856L23.3787 8.89907L25.6175 11.1379L14.4217 22.3337Z" fill="#076AFF"/>
     </svg>
   </div>
   <div class="O-content-container1">
     <p> Core billing services</p>
   </div>
 </div>
 <div class="O-container-item-1">
   <div class="O-checkbox-container">
     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
       <path d="M16.0003 31.8337C7.25558 31.8337 0.166992 24.7451 0.166992 16.0003C0.166992 7.25558 7.25558 0.166992 16.0003 0.166992C24.7451 0.166992 31.8337 7.25558 31.8337 16.0003C31.8337 24.7451 24.7451 31.8337 16.0003 31.8337ZM16.0003 28.667C19.3597 28.667 22.5816 27.3325 24.957 24.957C27.3325 22.5816 28.667 19.3597 28.667 16.0003C28.667 12.6409 27.3325 9.4191 24.957 7.04364C22.5816 4.66818 19.3597 3.33366 16.0003 3.33366C12.6409 3.33366 9.4191 4.66818 7.04364 7.04364C4.66818 9.4191 3.33366 12.6409 3.33366 16.0003C3.33366 19.3597 4.66818 22.5816 7.04364 24.957C9.4191 27.3325 12.6409 28.667 16.0003 28.667ZM14.4217 22.3337L7.70366 15.6156L9.94249 13.3767L14.4217 17.856L23.3787 8.89907L25.6175 11.1379L14.4217 22.3337Z" fill="#076AFF"/>
     </svg>
   </div>
   <div class="O-content-container1">
     <p> Core billing services</p>
   </div>
 </div>
          </div>
        </div>
        </div>
        <div className="O-overlay-content2">
            <h1 className="O-heading34">
            <span className="O-heading-part119">Focus on patient care and let us          </span>
            <span className="O-heading-part22">do the rest</span>
            </h1>
            <p className="O-paragraph23">
            To boost your team's capabilities and streamline operations, ___ offers revenue cycle management solutions aimed at enhancing your practice's financial health.
            </p>

            <div class="container-wrapper2">
 
 <div class="container-item2">
   <div class="checkbox-container2">
     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
       <path d="M16.0003 31.8337C7.25558 31.8337 0.166992 24.7451 0.166992 16.0003C0.166992 7.25558 7.25558 0.166992 16.0003 0.166992C24.7451 0.166992 31.8337 7.25558 31.8337 16.0003C31.8337 24.7451 24.7451 31.8337 16.0003 31.8337ZM16.0003 28.667C19.3597 28.667 22.5816 27.3325 24.957 24.957C27.3325 22.5816 28.667 19.3597 28.667 16.0003C28.667 12.6409 27.3325 9.4191 24.957 7.04364C22.5816 4.66818 19.3597 3.33366 16.0003 3.33366C12.6409 3.33366 9.4191 4.66818 7.04364 7.04364C4.66818 9.4191 3.33366 12.6409 3.33366 16.0003C3.33366 19.3597 4.66818 22.5816 7.04364 24.957C9.4191 27.3325 12.6409 28.667 16.0003 28.667ZM14.4217 22.3337L7.70366 15.6156L9.94249 13.3767L14.4217 17.856L23.3787 8.89907L25.6175 11.1379L14.4217 22.3337Z" fill="#076AFF"/>
     </svg>
   </div>
   <div class="content-container2">
     <p>Drive revenue growth.</p>
   </div>
 </div>
 <div class="container-item2">
   <div class="checkbox-container2">
     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
       <path d="M16.0003 31.8337C7.25558 31.8337 0.166992 24.7451 0.166992 16.0003C0.166992 7.25558 7.25558 0.166992 16.0003 0.166992C24.7451 0.166992 31.8337 7.25558 31.8337 16.0003C31.8337 24.7451 24.7451 31.8337 16.0003 31.8337ZM16.0003 28.667C19.3597 28.667 22.5816 27.3325 24.957 24.957C27.3325 22.5816 28.667 19.3597 28.667 16.0003C28.667 12.6409 27.3325 9.4191 24.957 7.04364C22.5816 4.66818 19.3597 3.33366 16.0003 3.33366C12.6409 3.33366 9.4191 4.66818 7.04364 7.04364C4.66818 9.4191 3.33366 12.6409 3.33366 16.0003C3.33366 19.3597 4.66818 22.5816 7.04364 24.957C9.4191 27.3325 12.6409 28.667 16.0003 28.667ZM14.4217 22.3337L7.70366 15.6156L9.94249 13.3767L14.4217 17.856L23.3787 8.89907L25.6175 11.1379L14.4217 22.3337Z" fill="#076AFF"/>
     </svg>
   </div>
   <div class="content-container2">
     <p>Optimize revenue streams.</p>
   </div>
 </div>
 <p className="O-paragraph23">
 Our solutions provide your practice with the flexibility and outreach needed to elevate service quality for your patients. They also ensure you stay ahead of compliance <br/>requirements by  improving collections.
            </p>
 <div class="container-item2">
   <div class="checkbox-container2">
     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
       <path d="M16.0003 31.8337C7.25558 31.8337 0.166992 24.7451 0.166992 16.0003C0.166992 7.25558 7.25558 0.166992 16.0003 0.166992C24.7451 0.166992 31.8337 7.25558 31.8337 16.0003C31.8337 24.7451 24.7451 31.8337 16.0003 31.8337ZM16.0003 28.667C19.3597 28.667 22.5816 27.3325 24.957 24.957C27.3325 22.5816 28.667 19.3597 28.667 16.0003C28.667 12.6409 27.3325 9.4191 24.957 7.04364C22.5816 4.66818 19.3597 3.33366 16.0003 3.33366C12.6409 3.33366 9.4191 4.66818 7.04364 7.04364C4.66818 9.4191 3.33366 12.6409 3.33366 16.0003C3.33366 19.3597 4.66818 22.5816 7.04364 24.957C9.4191 27.3325 12.6409 28.667 16.0003 28.667ZM14.4217 22.3337L7.70366 15.6156L9.94249 13.3767L14.4217 17.856L23.3787 8.89907L25.6175 11.1379L14.4217 22.3337Z" fill="#076AFF"/>
     </svg>
   </div>
   <div class="content-container2">
     <p>Performance analysis.</p>
   </div>
 </div>
 <div class="container-item2">
   <div class="checkbox-container2">
     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
       <path d="M16.0003 31.8337C7.25558 31.8337 0.166992 24.7451 0.166992 16.0003C0.166992 7.25558 7.25558 0.166992 16.0003 0.166992C24.7451 0.166992 31.8337 7.25558 31.8337 16.0003C31.8337 24.7451 24.7451 31.8337 16.0003 31.8337ZM16.0003 28.667C19.3597 28.667 22.5816 27.3325 24.957 24.957C27.3325 22.5816 28.667 19.3597 28.667 16.0003C28.667 12.6409 27.3325 9.4191 24.957 7.04364C22.5816 4.66818 19.3597 3.33366 16.0003 3.33366C12.6409 3.33366 9.4191 4.66818 7.04364 7.04364C4.66818 9.4191 3.33366 12.6409 3.33366 16.0003C3.33366 19.3597 4.66818 22.5816 7.04364 24.957C9.4191 27.3325 12.6409 28.667 16.0003 28.667ZM14.4217 22.3337L7.70366 15.6156L9.94249 13.3767L14.4217 17.856L23.3787 8.89907L25.6175 11.1379L14.4217 22.3337Z" fill="#076AFF"/>
     </svg>
   </div>
   <div class="content-container2">
     <p>Personalized dashboard.</p>
   </div>
 </div>
 <div class="container-item2">
   <div class="checkbox-container2">
     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
       <path d="M16.0003 31.8337C7.25558 31.8337 0.166992 24.7451 0.166992 16.0003C0.166992 7.25558 7.25558 0.166992 16.0003 0.166992C24.7451 0.166992 31.8337 7.25558 31.8337 16.0003C31.8337 24.7451 24.7451 31.8337 16.0003 31.8337ZM16.0003 28.667C19.3597 28.667 22.5816 27.3325 24.957 24.957C27.3325 22.5816 28.667 19.3597 28.667 16.0003C28.667 12.6409 27.3325 9.4191 24.957 7.04364C22.5816 4.66818 19.3597 3.33366 16.0003 3.33366C12.6409 3.33366 9.4191 4.66818 7.04364 7.04364C4.66818 9.4191 3.33366 12.6409 3.33366 16.0003C3.33366 19.3597 4.66818 22.5816 7.04364 24.957C9.4191 27.3325 12.6409 28.667 16.0003 28.667ZM14.4217 22.3337L7.70366 15.6156L9.94249 13.3767L14.4217 17.856L23.3787 8.89907L25.6175 11.1379L14.4217 22.3337Z" fill="#076AFF"/>
     </svg>
   </div>
   <div class="content-container2">
     <p>Billing insights.</p>
   </div>
 </div>
 <div class="container-item2">
   <div class="checkbox-container2">
     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
       <path d="M16.0003 31.8337C7.25558 31.8337 0.166992 24.7451 0.166992 16.0003C0.166992 7.25558 7.25558 0.166992 16.0003 0.166992C24.7451 0.166992 31.8337 7.25558 31.8337 16.0003C31.8337 24.7451 24.7451 31.8337 16.0003 31.8337ZM16.0003 28.667C19.3597 28.667 22.5816 27.3325 24.957 24.957C27.3325 22.5816 28.667 19.3597 28.667 16.0003C28.667 12.6409 27.3325 9.4191 24.957 7.04364C22.5816 4.66818 19.3597 3.33366 16.0003 3.33366C12.6409 3.33366 9.4191 4.66818 7.04364 7.04364C4.66818 9.4191 3.33366 12.6409 3.33366 16.0003C3.33366 19.3597 4.66818 22.5816 7.04364 24.957C9.4191 27.3325 12.6409 28.667 16.0003 28.667ZM14.4217 22.3337L7.70366 15.6156L9.94249 13.3767L14.4217 17.856L23.3787 8.89907L25.6175 11.1379L14.4217 22.3337Z" fill="#076AFF"/>
     </svg>
   </div>
   <div class="content-container2">
     <p>Quality metrics</p>
   </div>
 </div>
          </div>
        </div>
       
    </>
  );
};

export default Oncology;
